"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChartsDateFilterContext = void 0;
const react_1 = require("react");
const ChartsDateFilter_1 = require("@app/routes/Dashboard/components/ChartsDateFilter");
const useChartsDateFilterContext = () => (0, react_1.useContext)(ChartsDateFilter_1.ChartsDateFilterContext);
exports.useChartsDateFilterContext = useChartsDateFilterContext;
